export default __webpack_public_path__ + "static/media/base-logo.e14848ad.svg";